import { environment } from '../../../environments/environment';

export const appConfig = {
  apiUrl: environment.apiUrl,
  appName: 'taskeo',
  publicAppBaseUrl: environment.publicAppBaseUrl ?? '',
};
